import styled from 'styled-components/macro';
import { FONTS, FONT_FAMILY, FLEX_CONTAINER, COLORS } from 'utils/styles';
import { SIZE } from 'assets/styles/ScreenSize';

export const StyledRequestsPage = styled.div`
  ${FLEX_CONTAINER.FlexCenterColumn}
  padding-top: 50px;
  padding-bottom: 50px;
  margin-top: 50px;
  position: relative;
  min-height: calc(100vh - 232px);

  .start-request-wrapper {
    background: ${COLORS.multiGray};
    border-radius: 10px;

    @media (min-width: ${SIZE.mobile}) {
      width: 305px;
      height: 298px;
      padding: 16px 0 16px 17px;
    }

    @media (min-width: ${SIZE.iphone}) {
      width: 366px;
      height: 380px;
      padding: 17px 0 17px 17px;
    }

    @media (min-width: ${SIZE.tablet}) {
      width: 580px;
      height: 393px;
      padding: 25px 25px 0 25px;
    }

    @media (min-width: ${SIZE.desktop}) {
      width: 850px;
      height: 372px;
      padding: 30px 25px;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      width: 1200px;
      height: 514px;
      padding: 32px 34px;
    }

    .start-request {
      ${FLEX_CONTAINER.FlexStartRow}
    }

    .text {
      ${FONT_FAMILY.FontMedium}
      color: ${COLORS.mainColor};

      @media (min-width: ${SIZE.mobile}) {
        ${FONTS.font14}
        width: 202.3px;
      }

      @media (min-width: ${SIZE.iphone}) {
        ${FONTS.font16}
        width: 235.96px;
      }

      @media (min-width: ${SIZE.tablet}) {
        ${FONTS.font16}
        width: 374.93px;
      }

      @media (min-width: ${SIZE.desktop}) {
        ${FONTS.font16}
        width: 644.8px;
      }

      @media (min-width: ${SIZE.bigDesktop}) {
        ${FONTS.font20}
        width: 867.59px;
      }
    }

    .image-and-button {
      ${FLEX_CONTAINER.FlexStartRow};

      @media (min-width: ${SIZE.mobile}) {
        flex-direction: column;
        margin-top: 20px;
      }

      @media (min-width: ${SIZE.desktop}) {
        flex-direction: row;
        margin-top: 15px;
      }

      @media (min-width: ${SIZE.bigDesktop}) {
        flex-direction: row;
        margin-top: 20px;
      }

      .dest-image {
        @media (min-width: ${SIZE.mobile}) {
          width: 106px;
          height: 106px;
          margin-right: 80px;
          margin-bottom: 10px;
        }

        @media (min-width: ${SIZE.iphone}) {
          width: 154px;
          height: 154px;
          margin-right: 96px;
          margin-bottom: 40px;
        }

        @media (min-width: ${SIZE.tablet}) {
          width: 170px;
          height: 170px;
          margin-right: 120px;
          margin-bottom: 20px;
        }

        @media (min-width: ${SIZE.desktop}) {
          margin-right: 136px;
          width: 236px;
          height: 236px;
          margin-bottom: 0px;
        }

        @media (min-width: ${SIZE.bigDesktop}) {
          margin-right: 177px;
          width: 351px;
          height: 351px;
        }
      }
    }
  }

  .requests-countries-wrapper {
    ${FLEX_CONTAINER.FlexStartRow}
    background: ${COLORS.multiGray};
    border-radius: 25px;
    overflow: auto;

    @media (min-width: ${SIZE.mobile}) {
      width: 285px;
      height: 328px;
      padding: 15px 17px;
    }

    @media (min-width: ${SIZE.iphone}) {
      width: 366px;
      height: 380px;
      padding: 15px 17px;
    }

    @media (min-width: ${SIZE.tablet}) {
      width: 580px;
      height: 356.71px;
      padding: 23px 26px;
    }

    @media (min-width: ${SIZE.desktop}) {
      width: 850px;
      height: 372px;
      padding: 24px 25px;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      width: 1200px;
      height: 662px;
      padding: 35px 34px;
    }

    .from-big-phone {
      @media (min-width: ${SIZE.mobile}) {
        display: none;
      }

      @media (min-width: ${SIZE.iphone}) {
        display: block;
      }
    }

    .from-small-phone {
      @media (min-width: ${SIZE.mobile}) {
        ${FLEX_CONTAINER.FlexStartRow}

        .back-action {
          margin-right: 12px;
        }
      }

      @media (min-width: ${SIZE.iphone}) {
        display: none;
      }
    }

    .info-wrapper {
      @media (min-width: ${SIZE.mobile}) {
      }

      @media (min-width: ${SIZE.iphone}) {
        margin-left: 14px;
      }

      @media (min-width: ${SIZE.tablet}) {
        margin-left: 26px;
      }

      @media (min-width: ${SIZE.desktop}) {
        margin-left: 17px;
      }

      @media (min-width: ${SIZE.bigDesktop}) {
        margin-left: 28px;
      }

      .title {
        ${FONT_FAMILY.FontBold}
        color: ${COLORS.mainColor};

        @media (min-width: ${SIZE.mobile}) {
          ${FONTS.font14}
          margin-bottom: 10px;
        }

        @media (min-width: ${SIZE.iphone}) {
          ${FONTS.font16}
        }

        @media (min-width: ${SIZE.tablet}) {
          ${FONTS.font16}
          margin-bottom: 13px;
        }

        @media (min-width: ${SIZE.desktop}) {
          margin-bottom: 16px;
        }

        @media (min-width: ${SIZE.bigDesktop}) {
          ${FONTS.font20}
          margin-bottom: 20px;
        }
      }

      .sub {
        color: ${COLORS.mainColor};

        @media (min-width: ${SIZE.mobile}) {
          ${FONTS.font12}
        }

        @media (min-width: ${SIZE.iphone}) {
          ${FONTS.font14}
        }

        @media (min-width: ${SIZE.desktop}) {
          ${FONTS.font16}
        }
      }

      .card-wrapper {
        ${FLEX_CONTAINER.FlexSpaceBetweenRow}
        background: ${COLORS.ultralightGray};
        border-radius: 16px;
        margin-top: 24px;

        @media (min-width: ${SIZE.mobile}) {
          flex-direction: column;
          padding: 15px;
          width: 257.84px;
          height: auto;
        }

        @media (min-width: ${SIZE.iphone}) {
          padding: 13px 20px;
          width: 272.47px;
        }

        @media (min-width: ${SIZE.tablet}) {
          padding: 17px 32px;
          width: 450px;
        }

        @media (min-width: ${SIZE.desktop}) {
          flex-direction: row;
          padding: 17px 35px;
          width: 735px;
        }

        @media (min-width: ${SIZE.bigDesktop}) {
          padding: 22px 50px;
          width: 1074px;
        }

        .mobile {
          @media (min-width: ${SIZE.mobile}) {
            ${FLEX_CONTAINER.FlexSpaceBetweenRow}
          }

          @media (min-width: ${SIZE.tablet}) {
            display: none;
          }
        }

        .tablet-desc {
          @media (min-width: ${SIZE.mobile}) {
            display: none;
          }

          @media (min-width: ${SIZE.tablet}) {
            display: block;
          }
        }

        .image-title-info {
          ${FLEX_CONTAINER.FlexRow}
          color: ${COLORS.mainColor};

          @media (min-width: ${SIZE.mobile}) {
            ${FLEX_CONTAINER.FlexColumn}
          }

          @media (min-width: ${SIZE.tablet}) {
            ${FLEX_CONTAINER.FlexRow}
          }
        }

        .image-title {
          @media (min-width: ${SIZE.mobile}) {
          }

          @media (min-width: ${SIZE.iphone}) {
          }

          @media (min-width: ${SIZE.tablet}) {
            margin-right: 40px;
          }

          @media (min-width: ${SIZE.desktop}) {
            margin-right: 50px;
          }

          @media (min-width: ${SIZE.bigDesktop}) {
            margin-right: 70px;
          }

          .title {
            ${FONT_FAMILY.FontMedium};
            ${FONTS.font20};

            @media (min-width: ${SIZE.mobile}) {
              ${FONTS.font14}
              margin-bottom: 7px;
            }

            @media (min-width: ${SIZE.iphone}) {
              ${FONTS.font16}
              margin-bottom: 8px;
            }

            @media (min-width: ${SIZE.tablet}) {
              ${FONTS.font16}
              margin-bottom: 8px;
            }

            @media (min-width: ${SIZE.desktop}) {
              ${FONTS.font16};
            }

            @media (min-width: ${SIZE.bigDesktop}) {
              ${FONTS.font20}
              margin-bottom: 10px;
            }
          }
        }

        .requested {
          ${FONT_FAMILY.FontBold};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font14}
          }

          @media (min-width: ${SIZE.iphone}) {
            ${FONTS.font16}
          }

          @media (min-width: ${SIZE.desktop}) {
            ${FONTS.font16}
          }
        }

        .info {
          ${FONT_FAMILY.FontMedium};
          ${FONTS.font16};
          color: ${COLORS.mainColor};
          margin: 8px 0;

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font12}
            margin: 7px 0;
          }

          @media (min-width: ${SIZE.iphone}) {
            ${FONTS.font14}
            margin: 8px 0;
          }

          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font16}
          }

          @media (min-width: ${SIZE.bigDesktop}) {
            margin: 12px 0;
          }
        }

        .icons-wrapper {
          ${FLEX_CONTAINER.FlexRow};

          @media (min-width: ${SIZE.mobile}) {
            margin: 20px 0;
          }

          @media (min-width: ${SIZE.bigDesktop}) {
            margin: 0;
          }

          button {
            background: transparent;
            border: none;
          }

          img {
            @media (min-width: ${SIZE.mobile}) {
              width: 21px;
              height: 21px;
              margin-left: 20px;
            }

            @media (min-width: ${SIZE.desktop}) {
              margin-left: 20px;
            }

            @media (min-width: ${SIZE.bigDesktop}) {
              width: 28px;
              height: 28px;
              margin-left: 31px;
            }
          }
        }
      }
    }
  }

  .request-info-wrapper {
    ${FLEX_CONTAINER.FlexStartRow}
    width: 100%;
    align-items: flex-start;

    @media (min-width: ${SIZE.mobile}) {
      padding: 0 20px;
    }

    @media (min-width: ${SIZE.iphone}) {
      padding: 0 41px;
    }

    @media (min-width: ${SIZE.tablet}) {
      padding: 0 61px;
    }

    @media (min-width: ${SIZE.desktop}) {
      padding: 0 150px;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      padding: 0 150px;
    }

    .request-state-section {
      width: 100%;

      @media (min-width: ${SIZE.mobile}) {
        margin-left: 5px;
      }

      @media (min-width: ${SIZE.tablet}) {
        margin-left: 12px;
      }

      @media (min-width: ${SIZE.desktop}) {
        margin-left: 25px;
      }
    }

    .state-info {
      ${FLEX_CONTAINER.FlexRow}
      width: 100%;
      height: 120px;
      background: ${COLORS.multiGray};
      border-radius: 16px;

      @media (min-width: ${SIZE.mobile}) {
        height: 90px;
      }

      @media (min-width: ${SIZE.iphone}) {
        height: 80px;
      }

      @media (min-width: ${SIZE.tablet}) {
        height: 90px;
      }

      @media (min-width: ${SIZE.bigDesktop}) {
        height: 120px;
      }

      img {
        border-radius: 16px 0 0 16px;
        object-fit: cover;

        @media (min-width: ${SIZE.mobile}) {
          height: 90px;
          width: 72px;
        }

        @media (min-width: ${SIZE.iphone}) {
          height: 80px;
          width: 95px;
        }

        @media (min-width: ${SIZE.tablet}) {
          height: 90px;
          width: 135px;
        }

        @media (min-width: ${SIZE.bigDesktop}) {
          height: 120px;
          width: 222px;
        }
      }

      .request-info-text {
        margin-left: 37px;
        padding: 12px 0;

        @media (min-width: ${SIZE.mobile}) {
          margin-left: 12px;
          padding: 3px 0;
        }

        @media (min-width: ${SIZE.iphone}) {
          margin-left: 15px;
          padding: 5px 0;
        }

        @media (min-width: ${SIZE.tablet}) {
          margin-left: 26px;
          padding: 4px 0;
        }

        @media (min-width: ${SIZE.desktop}) {
          margin-left: 26px;
          padding: 4px 0;
        }

        @media (min-width: ${SIZE.bigDesktop}) {
          margin-left: 37px;
          padding: 11px 0;
        }

        .request-info-title {
          ${FONT_FAMILY.FontMedium}
          color: ${COLORS.mainColor};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font16}
          }

          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font16}
          }

          @media (min-width: ${SIZE.bigDesktop}) {
            ${FONTS.font20}
          }
        }

        .request-info-info {
          ${FONT_FAMILY.FontMedium}
          color: ${COLORS.mainColor};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font12}
            margin: 7px 0;
          }

          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font14}
            margin: 6px 0;
          }

          @media (min-width: ${SIZE.desktop}) {
            ${FONTS.font16}
          }

          @media (min-width: ${SIZE.bigDesktop}) {
            ${FONTS.font16}
            margin: 13px 0;
          }
        }
      }
    }

    .positions-wrapper {
      margin-top: 50px;

      @media (min-width: ${SIZE.mobile}) {
        margin-top: 24px;
      }

      @media (min-width: ${SIZE.iphone}) {
        margin-top: 30px;
      }

      @media (min-width: ${SIZE.bigDesktop}) {
        margin-top: 50px;
      }

      .item {
        ${FLEX_CONTAINER.FlexSpaceBetweenRow}
        width: 100%;
        height: auto;
        background: ${COLORS.ultralightGray};
        border-radius: 16px;

        @media (min-width: ${SIZE.mobile}) {
          margin-bottom: 24px;
          ${FLEX_CONTAINER.FlexSpaceBetweenColumn}
          padding: 15px;
        }

        @media (min-width: ${SIZE.iphone}) {
          margin-bottom: 30px;
          padding: 16px 20px;
        }

        @media (min-width: ${SIZE.tablet}) {
          margin-bottom: 30px;
          ${FLEX_CONTAINER.FlexSpaceBetweenRow}
          padding: 16px 35px;
        }

        @media (min-width: ${SIZE.desktop}) {
          margin-bottom: 25px;
          padding: 16px 35px;
        }

        @media (min-width: ${SIZE.bigDesktop}) {
          margin-bottom: 35px;
          padding: 22px 50px;
        }

        .item-title {
          color: ${COLORS.black};

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font14}
          }

          @media (min-width: ${SIZE.tablet}) {
            ${FONTS.font16}
          }
        }

        .item-info {
          ${FONT_FAMILY.FontSemiBold}
          color: ${COLORS.black};
          margin-top: 15px;

          @media (min-width: ${SIZE.mobile}) {
            ${FONTS.font14}
          }

          @media (min-width: ${SIZE.tablet}) {
            margin-top: 15px;
            ${FONTS.font16}
          }
        }

        .item-info:first-child {
          @media (min-width: ${SIZE.mobile}) {
            margin-top: 15px;
          }

          @media (min-width: ${SIZE.tablet}) {
            margin-top: 0;
          }
        }
      }
    }
  }
`;
